import { Request, Response } from "express"

import { getRecipes } from "#services/recipe/list"

export const routeGetRecipes = async (req: Request, res: Response) => {
	const list = await getRecipes({ categoryID: req.params.categoryID })

	res.json(list)
}
